import { TriggerKey } from '../userCommunicationAgent';

export const GBP_TRIGGER_KEYS = [
  TriggerKey.GBP_NEW_REVIEW,
  TriggerKey.GBP_UPDATED_REVIEW,
];

/** Step config for GBP_REPLY_REVIEW — replies to (or updates the reply on) a Google Business Profile review. */
export interface GbpReplyReviewStepConfig {
  /** Template string (supports {{variable}} substitution at runtime). */
  replyText: string;
  /** Review resource name override; defaults to the triggering review at runtime. */
  reviewName?: string;
}
